<template>
  <g class="menuIcon" transform="translate(2.5,2.5) matrix(0.3 0 0 0.3 0 0)">
    <path
      d="M32.0571 9V7.00037C32.0571 3.68666 29.3708 1.00037 26.0571 1.00037H24"
      stroke="#FFFEF4"
      stroke-width="1.8"
      fill="transparent"
    />
    <path
      d="M12 0.99999L10 0.99999C6.68629 0.99999 4 3.68628 4 6.99999L4 9"
      stroke="#FFFEF4"
      fill="transparent"
      stroke-width="1.8"
    />
    <path d="M4 21L4 23C4 26.3137 6.68629 29 10 29H12" stroke="#FFFEF4" stroke-width="1.8" fill="transparent" />
    <path d="M24 29L26 29C29.3137 29 32 26.3137 32 23L32 21" stroke="#FFFEF4" stroke-width="1.8" fill="transparent" />
    <line y1="15.0361" x2="36" y2="15.0361" stroke="#FFFEF4" fill="transparent" />
  </g>
</template>
